<template>
  <el-form-item prop="variableArr" ref="formItem" verify :rules="variableArrRules" class="sky-copy-multi-ostype">
    <div
      :class="['sky-copy-multi-ostype__item', 'sk-font--B', isFill(item) && 'active']"
      v-for="(item, index) in variableArr"
      :key="index"
    >
      <span>源产品版本：</span>
      <el-select
        v-model="item.sourceProductId"
        popper-class="sky-copy-multi-ostype__autocomplete"
        class="sky-copy-multi-ostype__select"
        filterable
      >
        <el-option v-for="(item, index) in sourceProductList" :key="index" :label="$t(item.label)" :value="item.id">
        </el-option>
      </el-select>
      <i class="el-icon-arrow-right" />
      <span>复制到目标产品版本：</span>
      <el-select
        v-model="item.targetProductId"
        @change="changeTarget"
        popper-class="sky-copy-multi-ostype__autocomplete"
        class="sky-copy-multi-ostype__select"
        filterable
      >
        <el-option
          v-for="(item, index) in targetProductList"
          :key="index"
          :label="$t(item.label)"
          :value="item.id"
          :disabled="selectIdList.includes(item.id)"
        >
        </el-option>
      </el-select>
      <i class="sk-icon-remove sk-font--B" @click="handleDelete(index)"></i>
    </div>
    <el-button
      v-show="this.variableArr.length < targetProductList.length"
      type="primary"
      class="sky-branch-pattern__add"
      style="margin-top:5px"
      @click="handleAdd"
    >
      添加复制项
    </el-button>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { OSTYPE_MNG } from '@/api/apiModules'

export default {
  name: 'SkyCopyMultiOsType',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      variableArr: [
        {
          sourceProductId: null,
          sourceProduct: null,
          targetProductId: null,
          targetProduct: null
        }
      ],
      loading: false,
      selectIdList: [],
      sourceProductList: [],
      targetProductList: []
    }
  },
  created() {
    this.variableArr = this.value ? this.value : []
    this.calcChange()
  },
  mounted() {
    action(OSTYPE_MNG, 'findProductForOsType').then(response => {
      this.sourceProductList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
    this.targetProductList = this.variableArr.map(item => {
      return {
        id: item.targetProductId,
        label: item.targetProduct
      }
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        let hasError = false
        if (this.variableArr.length) {
          for (const data of this.variableArr) {
            if (!this.isFill(data)) {
              hasError = true
              callback(new Error(this.$t('支持的复制项中源产品版本与目标产品版本不能为空')))
              break
            }
          }
        }
        if (this.isDuplicate()) {
          hasError = true
          callback(new Error(this.$t('支持的复制项组合不能重复')))
        }
        if (!hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    value(value) {
      if (this.value.length) {
        this.variableArr = this.value
      }
    },
    variableArr: {
      handler: function(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.sourceProductId && item.targetProductId
    },
    isDuplicate() {
      if (this.variableArr.length) {
        const set = new Set()
        return this.variableArr.some(obj => {
          const combination = obj['sourceProductId'] + '-' + obj['targetProductId']
          if (set.has(combination)) {
            return true
          } else {
            set.add(combination)
          }
        })
      }
    },
    handleAdd() {
      this.variableArr.push({
        sourceProductId: null,
        sourceProduct: null,
        targetProductId: null,
        targetProduct: null
      })
    },
    changeTarget() {
      this.calcChange()
    },
    handleDelete(index) {
      this.variableArr.splice(index, 1)
      this.calcChange()
    },
    calcChange() {
      this.selectIdList = []
      this.variableArr.map(item => {
        this.selectIdList.push(item.targetProductId)
      })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(copy-multi-ostype) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 200px;
  }
  @include e(select) {
    width: 280px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
